// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"257":"945965af","687":"945965af","814":"945965af","965":"945965af"}[chunkId] + ".chunk.css";
};